import React from 'react';
import { Helmet } from 'react-helmet';

export default ({ subtitle }: { subtitle?: string }) => (
    <Helmet>
        <html lang="en" />
        <style>{`
            .async-hide { opacity: 0 !important}
        `}</style>
        <script>{`
            (function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
            h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
            (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
            })(window,document.documentElement,'async-hide','dataLayer',4000,
            {'OPT-5Z967NK':true});
        `}</script>
        <meta charSet="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />

        <title>fieldmargin{subtitle ? ` - ${subtitle}` : ''}</title>

        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5" />

        <meta
            name="description"
            content="fieldmargin - Everything you need to run your farm at your fingertips. Maps, field work, livestock, inputs and reporting in one, easy to use app."
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="fieldmargin" />
        <meta property="og:title" content="fieldmargin - Your farm in your pocket." />
        <meta property="og:site_name" content="fieldmargin" />
        <meta property="og:url" content="https://www.fieldmargin.com/notes/index.html" />
        <meta
            property="og:description"
            content="fieldmargin - Everything you need to run your farm at your fingertips. Maps, field work, livestock, inputs and reporting in one, easy to use app."
        />
        <meta property="og:type" content="website" />
        <meta name="apple-itunes-app" content="app-id=1096607801" />
        <meta name="twitter:card" content="app" />
        <meta name="twitter:site" content="@fieldmargin" />
    </Helmet>
);
